// Next.js global-error.tsx (handles errors outside the segment tree).
// Must render its OWN <html> and <body> because the root layout has failed.
// Uses raw inline styles since the @theme CSS-vars MAY not have loaded.
'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Roda no NAVEGADOR (boundary client) — migalha de devtools, não o log do
    // servidor (Phase 265 / WR-08). Quem registra server-side é o próprio Next, ao
    // serializar o boundary, com o mesmo `error.digest` que a UI mostra em
    // "Código: {digest}". Procurar `[app/global-error]` no stdout do container não
    // acha nada — e não achar não significa que o erro não chegou ao servidor.
    console.error('[app/global-error]', error);
  }, [error]);

  return (
    <html lang="pt-BR">
      <body
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
          color: '#252525',
          background: '#FAFAFA',
          margin: 0,
        }}
      >
        <main
          style={{
            maxWidth: '28rem',
            padding: '2rem',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
            alignItems: 'center',
          }}
        >
          <h1
            style={{
              fontFamily: 'ui-serif, Georgia, serif',
              fontSize: '2rem',
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: '-0.01em',
              margin: 0,
            }}
          >
            Algo deu errado.
          </h1>
          <p
            style={{
              fontSize: '1rem',
              color: '#7A7A7A',
              lineHeight: 1.5,
              margin: 0,
            }}
          >
            Tente recarregar a página. Se o problema persistir, fale com o suporte.
          </p>
          {error.digest ? (
            <p style={{ fontSize: '0.875rem', color: '#7A7A7A', margin: 0 }}>
              Código: {error.digest}
            </p>
          ) : null}
        </main>
      </body>
    </html>
  );
}
